import angular from 'angular';
import uiRouter from 'angular-ui-router';
import feasibilityComponent from './feasibility.component';

import './feasibility.styl';

let feasibilityModule = angular.module('feasibility', [
  uiRouter
])

.config(($httpProvider, $stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/');
    $httpProvider.defaults.withCredentials = true;
    $stateProvider
        .state('feasibility', {
            url: '/feasibility',
            resolve: {
                currentData: (LoadedModel) => {
                    return LoadedModel.getCurrentSession();
                },
            },
            component: 'feasibility'
        });
})

.component('feasibility', feasibilityComponent)

.name;

export default feasibilityModule;



// WEBPACK FOOTER //
// ./client/app/components/feasibility/feasibility.js